(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!window.customElements.get('yg-footer-back-to-top')) {
    class YGFooterBackToTop extends HTMLElement {
      connectedCallback() {
        if (this.$link) {
          return;
        }

        this.$link = this.querySelector('a[href="#main"]');

        if (!this.$link) {
          return;
        }

        this.handleClick = this.handleClick.bind(this);
        this.$link.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        if (this.$link) {
          this.$link.removeEventListener('click', this.handleClick);
          this.$link = null;
        }
      }

      handleClick(event) {
        const main = document.getElementById('main');

        if (!main) {
          return;
        }

        event.preventDefault();
        main.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    window.customElements.define('yg-footer-back-to-top', YGFooterBackToTop);
  }

  if (!window.customElements.get('yg-footer-menu')) {
    class YGFooterMenu extends HTMLElement {
      connectedCallback() {
        if (this.$details) {
          return;
        }

        this.$details = this.querySelector('.footer__menu-mobile');
        this.$summary = this.$details?.querySelector('summary');
        this.$content = this.$details?.querySelector('.footer__menu-content');

        if (!this.$details || !this.$summary || !this.$content) {
          return;
        }

        this.handleSummaryClick = this.handleSummaryClick.bind(this);
        this.handleTransitionEnd = this.handleTransitionEnd.bind(this);
        this.$summary.addEventListener('click', this.handleSummaryClick);
        this.$content.addEventListener('transitionend', this.handleTransitionEnd);
      }

      disconnectedCallback() {
        this.$summary?.removeEventListener('click', this.handleSummaryClick);
        this.$content?.removeEventListener('transitionend', this.handleTransitionEnd);
        this.$details = null;
        this.$summary = null;
        this.$content = null;
      }

      handleSummaryClick(event) {
        event.preventDefault();

        if (this.$details.classList.contains('is-closing')) {
          return;
        }

        if (this.$details.open) {
          this.$details.classList.add('is-closing');
          return;
        }

        this.$details.classList.add('is-opening');
        this.$details.open = true;

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.$details.classList.remove('is-opening');
          });
        });
      }

      handleTransitionEnd(event) {
        if (event.propertyName !== 'grid-template-rows' || !this.$details.classList.contains('is-closing')) {
          return;
        }

        this.$details.open = false;
        this.$details.classList.remove('is-closing');
      }
    }

    window.customElements.define('yg-footer-menu', YGFooterMenu);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  if (!window.customElements.get('yg-collection-categories')) {
    class YGCollectionCategories extends HTMLElement {
      connectedCallback() {
        if (this.isInitialized) {
          return;
        }

        this.isInitialized = true;
        this.$toggle = this.querySelector('[data-yg-collection-categories-toggle]');
        this.$toggle?.addEventListener('click', this.handleToggle);
        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('keydown', this.handleKeydown);
      }

      disconnectedCallback() {
        this.$toggle?.removeEventListener('click', this.handleToggle);
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('keydown', this.handleKeydown);
        this.isInitialized = false;
      }

      handleToggle = () => {
        const isOpen = this.classList.toggle('is-open');
        this.$toggle?.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      };

      handleDocumentClick = (event) => {
        if (this.contains(event.target)) {
          return;
        }

        this.closeMenu();
      };

      handleKeydown = (event) => {
        if (event.key === 'Escape') {
          this.closeMenu();
        }
      };

      closeMenu() {
        this.classList.remove('is-open');
        this.$toggle?.setAttribute('aria-expanded', 'false');
      }
    }

    window.customElements.define('yg-collection-categories', YGCollectionCategories);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  class YGSlideshowProgressDots extends HTMLElement {
    connectedCallback() {
      this.$pageDots = this.querySelector('page-dots');
      this.$buttons = Array.from(this.querySelectorAll('page-dots > button'));
      this.duration = Number(this.getAttribute('duration')) * 1000;
      this.animationFrame = null;
      this.observer = new MutationObserver(this.handleSelectionChange);

      this.observer.observe(this.$pageDots, {
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-current'],
      });

      this.startProgress();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      window.cancelAnimationFrame(this.animationFrame);
    }

    handleSelectionChange = () => {
      this.startProgress();
    };

    startProgress() {
      window.cancelAnimationFrame(this.animationFrame);

      const $activeButton = this.$buttons.find(($button) => $button.getAttribute('aria-current') === 'true');

      this.$buttons.forEach(($button) => {
        $button.style.setProperty(
          '--yg-slideshow-progress',
          $button === $activeButton && !this.hasAttribute('autoplay') ? '1' : '0'
        );
      });

      if (!$activeButton || !this.hasAttribute('autoplay') || !this.duration) {
        return;
      }

      const startTime = window.performance.now();
      const updateProgress = (currentTime) => {
        const progress = Math.min((currentTime - startTime) / this.duration, 1);
        $activeButton.style.setProperty('--yg-slideshow-progress', progress.toString());

        if (progress < 1) {
          this.animationFrame = window.requestAnimationFrame(updateProgress);
        }
      };

      this.animationFrame = window.requestAnimationFrame(updateProgress);
    }
  }

  if (!window.customElements.get('yg-slideshow-progress-dots')) {
    window.customElements.define('yg-slideshow-progress-dots', YGSlideshowProgressDots);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-accordion-video-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGAccordionVideo01 extends YGUtils {
      constructor() {
        super();
        this.swiperInstance = null;
        this.isMobileMode = false;
        this.isInitializing = true;
        this.handleResize = this.handleResize.bind(this);
        this.debouncedResize = this.debounce(this.handleResize.bind(this), 150);
        this.handleItemHover = this.handleItemHover.bind(this);
        this.currentActiveItem = null;
      }

      get items() {
        return this.querySelectorAll('.yg-accordion-item');
      }

      connectedCallback() {
        this.handleResize();
        window.addEventListener('resize', this.debouncedResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.debouncedResize);
        this.destroySwiper();
        this.removeHoverListeners();
      }

      initSwiper() {
        if (this.swiperInstance) {
          return;
        }

        if (this.classList.contains('yg-accordion-folding-card') && this.isMobileMode) {
          return;
        }

        const galleryContainer = this.querySelector('.yg-accordion-item-container');
        if (!galleryContainer) {
          return;
        }

        this.swiperInstance = new Swiper(galleryContainer, {
          spaceBetween: 12,
          slidesPerView: 'auto',
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          autoHeight: true,
          on: {
            slideChange: () => {
              this.items.forEach((item) => {
                this.controlVideo(item, 'pause');
              });

              const activeSlide = galleryContainer.querySelector('.swiper-slide-active');
              if (activeSlide) {
                this.controlVideo(activeSlide, 'play');
              }
            },
          },
        });

        setTimeout(() => {
          const activeSlide = galleryContainer.querySelector('.swiper-slide-active');
          if (activeSlide) {
            this.controlVideo(activeSlide, 'play');
          }
        }, 100);
      }

      destroySwiper() {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      }

      handleResize() {
        const shouldBeMobile = window.innerWidth < 700;
        const modeChanged = shouldBeMobile !== this.isMobileMode;

        this.isMobileMode = shouldBeMobile;

        if (modeChanged || this.isInitializing) {
          if (shouldBeMobile) {
            this.removeHoverListeners();
            this.clearActiveItems();
            setTimeout(() => this.initSwiper(), 50);
          } else {
            this.destroySwiper();
            this.addHoverListeners();

            if (this.currentActiveItem) {
              this.currentActiveItem.classList.add('active');
              this.controlVideo(this.currentActiveItem, 'play');
            }
          }
        }

        this.isInitializing = false;
      }

      addHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleItemHover);
          item.addEventListener('mouseenter', this.handleItemHover);
          item.removeEventListener('mouseleave', this.handleItemHover);
          item.addEventListener('mouseleave', this.handleItemHover);
        });
      }

      removeHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleItemHover);
          item.removeEventListener('mouseleave', this.handleItemHover);
        });
      }

      clearActiveItems() {
        this.items.forEach((item) => item.classList.remove('active'));
        this.currentActiveItem = null;
      }

      controlVideo(item, action) {
        const videoElements = [...item.querySelectorAll('yg-video')];
        const videoElement = videoElements.find((element) => element.offsetParent !== null) || videoElements[0];
        if (videoElement && videoElement.pauseVideo && videoElement.playVideo) {
          const hasVideoContent = videoElement.type === 'video' && videoElement.videoContainer;
          if (hasVideoContent || videoElement.template) {
            if (action === 'play') {
              videoElement.playVideo();
            } else if (action === 'pause') {
              videoElement.pauseVideo();
            }
          }
        }
      }

      handleItemHover(event) {
        const target = event.currentTarget;

        if (event.type === 'mouseenter') {
          this.items.forEach((item) => {
            item.classList.remove('active');
            this.controlVideo(item, 'pause');
          });
          target.classList.add('active');
          this.controlVideo(target, 'play');
          this.currentActiveItem = target;
        } else if (event.type === 'mouseleave') {
          setTimeout(() => {
            const hoverItem = [...this.items].find((item) => item.matches(':hover'));
            if (!hoverItem && this.currentActiveItem) {
              this.currentActiveItem.classList.add('active');
              this.controlVideo(this.currentActiveItem, 'play');
            }
          }, 10);
        }
      }
    }

    if (!window.customElements.get('yg-accordion-video-01')) {
      window.customElements.define('yg-accordion-video-01', YGAccordionVideo01);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-banner-slide"] && !Shopify.designMode) return;
  try {
    
  class YGBannerSlide extends HTMLElement {
    constructor() {
      super();
      this.frameId = null;
      this.mountTimer = null;
      this.swiperEntries = [];
      this.requestUpdate = this.requestUpdate.bind(this);
      this.updateScrollProgress = this.updateScrollProgress.bind(this);
      this.syncMode = this.syncMode.bind(this);
      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
    }

    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.stories = Array.from(this.querySelectorAll('[data-story]'));
      this.desktopQuery = window.matchMedia('(min-width: 700px)');
      this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      this.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.desktopQuery.addEventListener?.('change', this.syncMode);
      this.reducedMotionQuery.addEventListener?.('change', this.syncMode);

      this.mountSwipers();
      this.syncMode();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.desktopQuery?.removeEventListener?.('change', this.syncMode);
      this.reducedMotionQuery?.removeEventListener?.('change', this.syncMode);
      this.detachWindowListeners();
      window.clearTimeout(this.mountTimer);

      if (this.frameId) {
        window.cancelAnimationFrame(this.frameId);
        this.frameId = null;
      }

      this.swiperEntries.forEach(({ swiper, handleSlideChange }) => {
        swiper.off('slideChange', handleSlideChange);
        if (!swiper.destroyed) {
          swiper.destroy(true, true);
        }
      });
      this.swiperEntries = [];
      this.initialized = false;
    }

    mountSwipers(attempt = 0) {
      const swiperElements = Array.from(this.querySelectorAll('[data-story-swiper]'));
      const allMounted = swiperElements.every((element) => element.swiper);

      if (!allMounted) {
        if (attempt < 20) {
          this.mountTimer = window.setTimeout(() => this.mountSwipers(attempt + 1), 100);
        }
        return;
      }

      this.swiperEntries = swiperElements.map((element) => {
        const story = element.closest('[data-story]');
        const swiper = element.swiper;
        const handleSlideChange = () => this.syncTabState(story, swiper);

        swiper.on('slideChange', handleSlideChange);
        this.syncTabState(story, swiper);

        return { story, swiper, handleSlideChange };
      });

      this.syncMode();
    }

    syncMode() {
      this.detachWindowListeners();

      window.addEventListener('scroll', this.requestUpdate, { passive: true });
      window.addEventListener('resize', this.requestUpdate);
      this.listeningToWindow = true;

      if (this.desktopQuery.matches) {
        this.swiperEntries.forEach(({ swiper }) => this.configureSwiper(swiper, false));
        this.requestUpdate();
        return;
      }

      this.stories.forEach((story) => {
        story.style.setProperty('--story-progress', '0');
        story.removeAttribute('data-active');
      });
      this.swiperEntries.forEach(({ swiper }) => {
        this.configureSwiper(swiper, !this.reducedMotionQuery.matches);
      });
      this.requestUpdate();
    }

    configureSwiper(swiper, enableAutoplay) {
      swiper.allowTouchMove = !this.desktopQuery.matches;
      swiper.params.allowTouchMove = !this.desktopQuery.matches;

      if (!swiper.autoplay) return;

      swiper.params.autoplay.waitForTransition = false;
      swiper.params.autoplay.pauseOnMouseEnter = false;

      if (enableAutoplay) {
        swiper.autoplay.stop();
        swiper.autoplay.start();
      } else {
        swiper.autoplay.stop();
      }
    }

    detachWindowListeners() {
      if (!this.listeningToWindow) return;

      window.removeEventListener('scroll', this.requestUpdate);
      window.removeEventListener('resize', this.requestUpdate);
      this.listeningToWindow = false;
    }

    requestUpdate() {
      if (this.frameId) return;
      this.frameId = window.requestAnimationFrame(this.updateScrollProgress);
    }

    updateScrollProgress() {
      this.frameId = null;
      this.updateStickyOffset();
      if (!this.desktopQuery.matches || this.stories.length === 0) return;

      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const sectionTop = this.getBoundingClientRect().top + window.scrollY;
      const localScroll = window.scrollY - sectionTop;
      const activeIndex = Math.max(0, Math.min(Math.floor(localScroll / viewportHeight), this.stories.length - 1));

      this.stories.forEach((story, index) => {
        const storyScroll = localScroll - index * viewportHeight;
        const progress = Math.max(0, Math.min(storyScroll / viewportHeight, 1));

        story.style.setProperty('--story-progress', progress.toFixed(4));
        story.toggleAttribute('data-active', index === activeIndex);
      });
    }

    updateStickyOffset() {
      if (this.desktopQuery.matches) {
        this.style.removeProperty('--banner-slide-sticky-offset');
        this.style.removeProperty('--banner-slide-fixed-bottom-offset');
        return;
      }

      let stickyOffset = 0;
      const stickyElements = document.querySelectorAll(
        '.shopify-section--header, .shopify-section.yg-anchor-tab.is-active'
      );

      stickyElements.forEach((element) => {
        if (this.contains(element)) return;

        const style = window.getComputedStyle(element);
        if (style.display === 'none' || style.visibility === 'hidden' || Number.parseFloat(style.opacity) === 0) return;

        const rect = element.getBoundingClientRect();
        const joinsStickyStack = rect.top <= stickyOffset + 2 && rect.bottom > stickyOffset;
        if (joinsStickyStack && rect.bottom < window.innerHeight / 2) {
          stickyOffset = rect.bottom;
        }
      });

      this.style.setProperty('--banner-slide-sticky-offset', `${Math.max(0, Math.round(stickyOffset))}px`);

      let fixedBottomOffset = 0;
      const stickyNav = document.querySelector('.shopify-section.yg-anchor-tab.is-active');
      const candidates = [];

      if (stickyNav) {
        candidates.push(stickyNav);
        const innerBar = stickyNav.querySelector('.yg-current-variant-container');
        if (innerBar) candidates.push(innerBar);
      }

      candidates.forEach((element) => {
        const style = window.getComputedStyle(element);
        const rect = element.getBoundingClientRect();
        const isVisible =
          style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          Number.parseFloat(style.opacity) !== 0 &&
          rect.height > 0;
        const isFixedToViewportBottom =
          style.position === 'fixed' && rect.top < window.innerHeight && rect.bottom >= window.innerHeight - 2;

        if (isVisible && isFixedToViewportBottom) {
          fixedBottomOffset = Math.max(fixedBottomOffset, window.innerHeight - rect.top);
        }
      });

      this.style.setProperty('--banner-slide-fixed-bottom-offset', `${Math.max(0, Math.round(fixedBottomOffset))}px`);
    }

    handleClick(event) {
      const tab = event.target.closest('.yg-banner-slide__tab');
      if (!tab || !this.desktopQuery.matches) return;

      this.activateTab(tab.closest('[data-story]'), Number(tab.dataset.tabIndex));
    }

    handleKeydown(event) {
      const tab = event.target.closest('.yg-banner-slide__tab');
      if (!tab || !this.desktopQuery.matches) return;

      const story = tab.closest('[data-story]');
      const tabs = Array.from(story.querySelectorAll('.yg-banner-slide__tab'));
      const currentIndex = Number(tab.dataset.tabIndex);
      let nextIndex = currentIndex;

      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.activateTab(story, currentIndex);
        return;
      }

      if (event.key === 'ArrowLeft') {
        nextIndex = currentIndex > 0 ? currentIndex - 1 : tabs.length - 1;
      } else if (event.key === 'ArrowRight') {
        nextIndex = currentIndex < tabs.length - 1 ? currentIndex + 1 : 0;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      tabs[nextIndex]?.focus();
      this.activateTab(story, nextIndex);
    }

    activateTab(story, index) {
      const entry = this.swiperEntries.find((item) => item.story === story);
      if (!entry || !Number.isInteger(index)) return;

      if (typeof entry.swiper.slideToLoop === 'function') {
        entry.swiper.slideToLoop(index);
      } else {
        entry.swiper.slideTo(index);
      }
    }

    syncTabState(story, swiper) {
      if (!story) return;

      const activeIndex = typeof swiper.realIndex === 'number' ? swiper.realIndex : swiper.activeIndex;
      story.querySelectorAll('.yg-banner-slide__tab').forEach((tab) => {
        const isActive = Number(tab.dataset.tabIndex) === activeIndex;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      story.querySelectorAll('.yg-banner-slide__slide').forEach((slide) => {
        slide.setAttribute('aria-hidden', String(Number(slide.dataset.tabIndex) !== activeIndex));
      });
    }

    handleBlockSelect(event) {
      const story = event.target.closest('[data-story]');
      if (!story) return;

      if (this.desktopQuery.matches) {
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const sectionTop = this.getBoundingClientRect().top + window.scrollY;
        const storyIndex = Number(story.dataset.storyIndex) || 0;
        window.scrollTo({
          top: sectionTop + storyIndex * viewportHeight,
          behavior: this.reducedMotionQuery.matches ? 'auto' : 'smooth',
        });
      } else {
        story.scrollIntoView({
          block: 'start',
          behavior: this.reducedMotionQuery.matches ? 'auto' : 'smooth',
        });
      }
    }
  }

  if (!window.customElements.get('yg-banner-slide')) {
    window.customElements.define('yg-banner-slide', YGBannerSlide);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-blog-grid"] && !Shopify.designMode) return;
  try {
    
  class YGBlogGrid extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.mobileMediaQuery = window.matchMedia('(max-width: 699px)');
      this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
    }

    connectedCallback() {
      this.mobileMediaQuery.addEventListener('change', this.handleBreakpointChange);
      this.handleBreakpointChange();
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.handleBreakpointChange);
      this.destroySwiper();
    }

    get swiperElement() {
      return this.querySelector('[data-blog-grid-swiper]');
    }

    handleBreakpointChange() {
      if (this.mobileMediaQuery.matches) {
        this.initSwiper();
      } else {
        this.destroySwiper();
      }
    }

    initSwiper() {
      if (this.swiper || !this.swiperElement || typeof Swiper === 'undefined') {
        return;
      }

      this.swiper = new Swiper(this.swiperElement, {
        slidesPerView: 1.2,
        spaceBetween: 8,
        watchOverflow: true,
      });
    }

    destroySwiper() {
      if (!this.swiper) {
        return;
      }

      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  if (!window.customElements.get('yg-blog-grid')) {
    window.customElements.define('yg-blog-grid', YGBlogGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-intelligence-tabs"] && !Shopify.designMode) return;
  try {
    
  class YGIntelligenceTabs extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0;
      this.mediaSwiper = null;
      this.mountTimer = null;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.handleTabClick = this.handleTabClick.bind(this);
      this.handleTabKeydown = this.handleTabKeydown.bind(this);
      this.handleMediaSlideChange = this.handleMediaSlideChange.bind(this);
      this.handleMotionChange = this.handleMotionChange.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    get sectionElements() {
      if (this._sectionElements) {
        return this._sectionElements;
      }

      this._sectionElements = {
        tabsTrack: this.querySelector('[data-tabs-track]'),
        tabsScroll: this.querySelector('[data-tabs-scroll]'),
        tabs: Array.from(this.querySelectorAll('.yg-intelligence-tabs__tab')),
        mediaSwiper: this.querySelector('[data-media-swiper]'),
      };

      return this._sectionElements;
    }

    connectedCallback() {
      if (this.initialized) {
        return;
      }

      this.initialized = true;
      this.sectionElements.tabs.forEach((tab) => tab.addEventListener('click', this.handleTabClick));
      this.sectionElements.tabsTrack?.addEventListener('keydown', this.handleTabKeydown);
      window.addEventListener('resize', this.handleResize);

      if (this.motionQuery.addEventListener) {
        this.motionQuery.addEventListener('change', this.handleMotionChange);
      } else {
        this.motionQuery.addListener(this.handleMotionChange);
      }

      this.mountSwiper();
    }

    disconnectedCallback() {
      this.sectionElements.tabs.forEach((tab) => tab.removeEventListener('click', this.handleTabClick));
      this.sectionElements.tabsTrack?.removeEventListener('keydown', this.handleTabKeydown);
      window.removeEventListener('resize', this.handleResize);
      window.clearTimeout(this.mountTimer);

      if (this.motionQuery.removeEventListener) {
        this.motionQuery.removeEventListener('change', this.handleMotionChange);
      } else {
        this.motionQuery.removeListener(this.handleMotionChange);
      }

      if (this.mediaSwiper) {
        this.mediaSwiper.off('slideChange', this.handleMediaSlideChange);
        this.mediaSwiper = null;
      }

      this.initialized = false;
    }

    mountSwiper(attempt = 0) {
      const mediaSwiperElement = this.sectionElements.mediaSwiper;
      if (!mediaSwiperElement) {
        return;
      }

      if (!mediaSwiperElement.swiper) {
        if (attempt < 10) {
          this.mountTimer = window.setTimeout(() => this.mountSwiper(attempt + 1), 150);
        }
        return;
      }

      this.mediaSwiper = mediaSwiperElement.swiper;
      this.mediaSwiper.allowTouchMove = this.sectionElements.tabs.length > 1;
      this.mediaSwiper.params.allowTouchMove = this.sectionElements.tabs.length > 1;
      this.mediaSwiper.on('slideChange', this.handleMediaSlideChange);
      this.setActiveState(0, { syncSwiper: false, scrollBehavior: 'auto' });
      this.handleMotionChange();
    }

    handleTabClick(event) {
      this.setActiveState(Number(event.currentTarget.dataset.tabIndex));
    }

    handleTabKeydown(event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        return;
      }

      const lastIndex = this.sectionElements.tabs.length - 1;
      let nextIndex = this.activeIndex;

      if (event.key === 'ArrowLeft') {
        nextIndex = this.activeIndex > 0 ? this.activeIndex - 1 : lastIndex;
      } else if (event.key === 'ArrowRight') {
        nextIndex = this.activeIndex < lastIndex ? this.activeIndex + 1 : 0;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = lastIndex;
      }

      event.preventDefault();
      this.sectionElements.tabs[nextIndex]?.focus();
      this.setActiveState(nextIndex);
    }

    handleMediaSlideChange() {
      const nextIndex =
        typeof this.mediaSwiper.realIndex === 'number' ? this.mediaSwiper.realIndex : this.mediaSwiper.activeIndex;

      this.setActiveState(nextIndex, { syncSwiper: false });
    }

    handleMotionChange() {
      if (!this.mediaSwiper?.autoplay) {
        return;
      }

      if (this.motionQuery.matches) {
        this.mediaSwiper.autoplay.stop();
      } else if (this.dataset.autoplayEnabled === 'true') {
        this.mediaSwiper.autoplay.start();
      }
    }

    handleResize() {
      this.updateIndicator();
      this.scrollActiveTabIntoView('auto');
    }

    setActiveState(index, options = {}) {
      const safeIndex = Math.max(0, Math.min(index, this.sectionElements.tabs.length - 1));
      const syncSwiper = options.syncSwiper !== false;
      const scrollBehavior = options.scrollBehavior || 'smooth';

      this.activeIndex = safeIndex;

      if (syncSwiper && this.mediaSwiper && this.mediaSwiper.activeIndex !== safeIndex) {
        this.mediaSwiper.slideTo(safeIndex);
      }

      this.sectionElements.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === safeIndex;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.updateIndicator();
      this.scrollActiveTabIntoView(scrollBehavior);
      this.playActiveVideo();
    }

    updateIndicator() {
      const activeTab = this.sectionElements.tabs[this.activeIndex];
      if (!activeTab || !this.sectionElements.tabsTrack) {
        return;
      }

      this.sectionElements.tabsTrack.style.setProperty(
        '--yg-intelligence-tabs-indicator-left',
        String(activeTab.offsetLeft) + 'px'
      );
      this.sectionElements.tabsTrack.style.setProperty(
        '--yg-intelligence-tabs-indicator-width',
        String(activeTab.offsetWidth) + 'px'
      );
    }

    scrollActiveTabIntoView(behavior) {
      const scrollContainer = this.sectionElements.tabsScroll;
      const activeTab = this.sectionElements.tabs[this.activeIndex];

      if (!scrollContainer || !activeTab || scrollContainer.scrollWidth <= scrollContainer.clientWidth + 1) {
        return;
      }

      const containerRect = scrollContainer.getBoundingClientRect();
      const tabRect = activeTab.getBoundingClientRect();
      const rawScrollLeft =
        scrollContainer.scrollLeft +
        (tabRect.left - containerRect.left) -
        (scrollContainer.clientWidth - tabRect.width) / 2;
      const maxScrollLeft = Math.max(scrollContainer.scrollWidth - scrollContainer.clientWidth, 0);
      const nextScrollLeft = Math.min(Math.max(rawScrollLeft, 0), maxScrollLeft);

      scrollContainer.scrollTo({ left: nextScrollLeft, behavior: behavior });
    }

    pauseAllVideos() {
      this.querySelectorAll('.yg-intelligence-tabs__slide yg-video').forEach((videoElement) => {
        if (typeof videoElement.pauseVideo === 'function') {
          videoElement.pauseVideo();
        }
      });
    }

    playActiveVideo() {
      this.pauseAllVideos();
      const activeSlide = this.querySelector(
        '.yg-intelligence-tabs__slide[data-slide-index="' + this.activeIndex + '"]'
      );
      const activeVideo = activeSlide?.querySelector('yg-video');

      if (activeVideo && typeof activeVideo.playVideo === 'function') {
        activeVideo.playVideo();
      }
    }
  }

  if (!window.customElements.get('yg-intelligence-tabs')) {
    window.customElements.define('yg-intelligence-tabs', YGIntelligenceTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-compare-v3"] && !Shopify.designMode) return;
  try {
     
  document.addEventListener('DOMContentLoaded', () => {
    // 让 Vue 忽略以 yg- 开头的自定义标签（如 yg-image、yg-select 等），避免 Unknown custom element 报错
    if (window.Vue && Vue.config) {
      Vue.config.ignoredElements = Vue.config.ignoredElements || [];
      Vue.config.ignoredElements.push(/^yg-/);
    }

    class YGProductCompareV3 extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.handleWindowScroll = this.handleWindowScroll.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleTopBarScroll = this.handleTopBarScroll.bind(this);
        this.handleFloatingTopBarScroll = this.handleFloatingTopBarScroll.bind(this);
        this.handleTopScroll = this.handleTopScroll.bind(this);
        this.handleDataScroll = this.handleDataScroll.bind(this);
      }
      get isFloatingTopBarEnabled() {
        return this.dataset.enableFloatingTopBar === 'true';
      }
      get sectionsEl() {
        if (this._sectionsEl) return this._sectionsEl;
        this._sectionsEl = {
          'product-form': this.querySelector('#yg-product-form') || this.querySelector('.yg-product-form'),
          'product-form-id': this.querySelector('#yg-product-form-id') || this.querySelector('.yg-product-form-id'),
          'product-data': this.querySelector('.yg-product-data'),
          'product-top-bar-shell': this.querySelector('.yg-product-top-bar-shell'),
          'product-top-bar-scroll': this.querySelector('.yg-product-compare-top-bar-container'),
          'floating-top-bar-shell': this.querySelector('.yg-product-floating-top-bar-shell'),
          'floating-top-bar-scroll': this.querySelector('.yg-product-floating-top-bar-container'),
          'product-top-scroll': this.querySelector('.yg-product-compare-top-container'),
          'product-data-scroll': this.querySelector('.yg-product-compare-data-container'),
        };

        return this._sectionsEl;
      }
      connectedCallback() {
        this.initVue();

        if (!this._eventsBound) {
          this.addEventListener('click', this.handleClick);
          window.addEventListener('resize', this.handleResize);
          this.sectionsEl['product-top-bar-scroll']?.addEventListener('scroll', this.handleTopBarScroll, { passive: true });
          this.sectionsEl['product-top-scroll']?.addEventListener('scroll', this.handleTopScroll, { passive: true });
          this.sectionsEl['product-data-scroll']?.addEventListener('scroll', this.handleDataScroll, { passive: true });
          if (this.isFloatingTopBarEnabled) {
            window.addEventListener('scroll', this.handleWindowScroll, { passive: true });
            this.sectionsEl['floating-top-bar-scroll']?.addEventListener('scroll', this.handleFloatingTopBarScroll, {
              passive: true,
            });
          }
          this._eventsBound = true;
        }

        this.handleResize();
        this.refreshDynamicHeights();
        if (this.isFloatingTopBarEnabled) {
          this.requestFloatingNavStateUpdate();
        }
      }
      disconnectedCallback() {
        if (!this._eventsBound) return;

        this.removeEventListener('click', this.handleClick);
        window.removeEventListener('resize', this.handleResize);
        this.sectionsEl['product-top-bar-scroll']?.removeEventListener('scroll', this.handleTopBarScroll);
        this.sectionsEl['product-top-scroll']?.removeEventListener('scroll', this.handleTopScroll);
        this.sectionsEl['product-data-scroll']?.removeEventListener('scroll', this.handleDataScroll);
        if (this.isFloatingTopBarEnabled) {
          window.removeEventListener('scroll', this.handleWindowScroll);
          this.sectionsEl['floating-top-bar-scroll']?.removeEventListener('scroll', this.handleFloatingTopBarScroll);
          this.closeTopBarDropdowns();
        }
        if (this._floatingNavFrame) {
          cancelAnimationFrame(this._floatingNavFrame);
          this._floatingNavFrame = null;
        }
        this._eventsBound = false;
      }
      initVue() {
        if (this._vue) return;

        if (!window.Vue || !window.ELEMENT) {
          console.warn('[yg-product-compare-v3] Vue or Element UI is not available.');
          return;
        }

        let _this = this;
        this._vue = new Vue({
          el: _this.querySelector('.yg-select-vue'),
          delimiters: ['${', '}'],
          data() {
            let initialState = {
              options: [],
              values: [],
              hideDuplicates: false,
              primaryRowCount: 0,
              groupRowCounts: {},
              isCondensedLayout: false,
              variantsCurrent: [
                { id: null, price: null, featured_image: null, available: null },
                { id: null, price: null, featured_image: null, available: null },
                { id: null, price: null, featured_image: null, available: null },
              ],
            };

            const textarea = _this.querySelector('#compare-data');
            if (textarea) {
              const raw = (textarea.value || textarea.textContent || '').trim();
              if (raw) {
                let parsed;
                try {
                  parsed = JSON.parse(raw);
                } catch (error) {
                  parsed = new Function('return ' + raw)();
                }
                if (parsed && Array.isArray(parsed.options)) {
                  initialState.options = parsed.options;
                }

                initialState.values = initialState.options.slice(0, 3).map((opt) => opt.value);
                initialState.variantsCurrent = [];
                initialState.values.forEach((handle) => {
                  const opt = initialState.options.find((option) => option && option.value === handle);
                  const variants = opt && opt.data && Array.isArray(opt.data.variants) ? opt.data.variants : [];
                  const firstVariant = variants[0] || null;
                  initialState.variantsCurrent.push({
                    id: firstVariant ? firstVariant.id : null,
                    price: firstVariant ? firstVariant.price : null,
                    featured_image:
                      firstVariant && firstVariant.featured_image ? firstVariant.featured_image.src : null,
                    available: firstVariant ? firstVariant.available : null,
                  });
                });

                while (initialState.variantsCurrent.length < 3) {
                  initialState.variantsCurrent.push({
                    id: null,
                    price: null,
                    featured_image: null,
                    available: null,
                  });
                }
              }
            }

            return initialState;
          },
          mounted() {
            this.primaryRowCount = _this.querySelectorAll('.yg-product-data-group > .row').length;

            const groupRowCounts = {};
            _this.querySelectorAll('.yg-product-dropdown-wrap').forEach((groupWrap) => {
              const groupIndex = Number(groupWrap.dataset.groupIndex);
              if (Number.isNaN(groupIndex)) return;
              groupRowCounts[groupIndex] = groupWrap.querySelectorAll('.row').length;
            });
            this.groupRowCounts = groupRowCounts;

            _this.syncResponsiveState();
            this.handleSpecificationVisibilityChange();
          },
          watch: {
            hideDuplicates() {
              this.handleSpecificationVisibilityChange();
            },
            values: {
              deep: true,
              handler() {
                this.handleSpecificationVisibilityChange();
              },
            },
            isCondensedLayout() {
              this.handleSpecificationVisibilityChange();
            },
          },
          methods: {
            formatMoney(cents) {
              const format = _this.getAttribute('data-currency-format');
              const valueNumber = Number(cents) || 0;
              const amount = valueNumber / 100;
              const amountStr = amount.toFixed(2);
              return format + amountStr;
            },
            handleProductChange(columnIndex, newColumnValue) {
              const variants = (this.variantsMap && this.variantsMap[newColumnValue]) || [];
              const nextVariant = variants[0] || null;
              const nextId = nextVariant ? nextVariant.id : null;

              this.$set(this.variantsCurrent, columnIndex, {
                id: nextId,
                price: nextVariant ? nextVariant.price : null,
                featured_image: nextVariant && nextVariant.featured_image ? nextVariant.featured_image.src : null,
                available: nextVariant ? nextVariant.available : null,
              });
              if (nextId != null) this.handleVariantChange(newColumnValue, nextId, columnIndex);
            },
            handleVariantChange(columnValue, variantId, columnIndex) {
              const variants = (this.variantsMap && this.variantsMap[columnValue]) || [];
              const selected = variants.find((variant) => variant && String(variant.id) === String(variantId)) || null;
              const price = selected ? selected.price : null;
              const featuredImage = selected && selected.featured_image ? selected.featured_image.src : null;
              const available = selected ? selected.available : null;

              if (typeof columnIndex === 'number') {
                const previous = (this.variantsCurrent && this.variantsCurrent[columnIndex]) || {};
                this.$set(this.variantsCurrent, columnIndex, {
                  ...previous,
                  id: variantId,
                  price,
                  featured_image: featuredImage,
                  available,
                });
              }
            },
            getVariantOptionValue(columnValue, item) {
              const position = (this.variantPositionMap && this.variantPositionMap[columnValue]) || 1;
              const key = 'option' + String(position);
              return (item && item[key]) || (item && item.public_title) || '';
            },
            getVariantLabel(columnValue, item) {
              const value = this.getVariantOptionValue(columnValue, item);
              return value || (item && item.public_title) || '';
            },
            getColorSwatchStyle(columnValue, item) {
              const value = this.getVariantOptionValue(columnValue, item);
              const key = String(value || '')
                .toLowerCase()
                .trim();
              const map = (this.colorSwatchMap && this.colorSwatchMap[columnValue]) || {};
              return map[key] || '';
            },
            buildMapFromOptions(getValueFn) {
              const map = {};
              (this.options || []).forEach((option) => {
                if (!option || option.value == null) return;
                const value = getValueFn(option);
                if (value != null) {
                  map[option.value] = value;
                }
              });
              return map;
            },
            normalizeComparableValue(value) {
              if (value == null) return '';
              return String(value).trim();
            },
            getVisibleColumnIndices() {
              const maxCount = this.isCondensedLayout ? 2 : Math.min(this.values.length, 3);
              return this.values
                .slice(0, maxCount)
                .map((_, index) => index)
                .filter((index) => this.values[index]);
            },
            shouldHideComparableValues(values) {
              if (!this.hideDuplicates || values.length < 2) return false;
              const firstValue = values[0];
              return values.every((value) => value === firstValue);
            },
            getPrimaryRowComparableValue(columnIndex, rowIndex) {
              const handle = this.values[columnIndex];
              if (!handle) return '';
              const imageValue = ((this.specificationImageMap[handle] || [])[rowIndex]) || '';
              const textValue = ((this.specificationListMap[handle] || [])[rowIndex]) || '';
              return [
                this.normalizeComparableValue(imageValue),
                this.normalizeComparableValue(textValue),
              ].join('||');
            },
            shouldHidePrimaryRow(rowIndex) {
              const rowValues = this.getVisibleColumnIndices().map((columnIndex) =>
                this.getPrimaryRowComparableValue(columnIndex, rowIndex),
              );
              return this.shouldHideComparableValues(rowValues);
            },
            getGroupSpecificationMap(groupIndex) {
              const groupMaps = {
                1: this.specificationListGroup1Map,
                2: this.specificationListGroup2Map,
                3: this.specificationListGroup3Map,
                4: this.specificationListGroup4Map,
                5: this.specificationListGroup5Map,
              };
              return groupMaps[groupIndex] || {};
            },
            getGroupRowDisplayValue(groupIndex, columnIndex, rowIndex) {
              const handle = this.values[columnIndex];
              if (!handle) return '';
              const groupMap = this.getGroupSpecificationMap(groupIndex);
              const rawValue = ((groupMap[handle] || [])[rowIndex]);
              if (rawValue === '.') return '.';
              if (rawValue == null || rawValue === '') return '-';
              return this.normalizeComparableValue(rawValue);
            },
            shouldHideGroupRow(groupIndex, rowIndex) {
              const rowValues = this.getVisibleColumnIndices().map((columnIndex) =>
                this.getGroupRowDisplayValue(groupIndex, columnIndex, rowIndex),
              );
              return this.shouldHideComparableValues(rowValues);
            },
            isGroupFullyHidden(groupIndex, rowCount) {
              if (!this.hideDuplicates) return false;
              const totalRows = Number(rowCount) || 0;
              if (totalRows === 0) return true;

              for (let rowIndex = 0; rowIndex < totalRows; rowIndex += 1) {
                if (!this.shouldHideGroupRow(groupIndex, rowIndex)) {
                  return false;
                }
              }

              return true;
            },
            hasVisiblePrimaryRows() {
              const totalRows = Number(this.primaryRowCount) || 0;
              for (let rowIndex = 0; rowIndex < totalRows; rowIndex += 1) {
                if (!this.shouldHidePrimaryRow(rowIndex)) {
                  return true;
                }
              }

              return false;
            },
            hasVisibleGroupedRows() {
              const groupRowCounts = this.groupRowCounts || {};
              return Object.keys(groupRowCounts).some((groupIndex) => {
                return !this.isGroupFullyHidden(Number(groupIndex), groupRowCounts[groupIndex]);
              });
            },
            handleSpecificationVisibilityChange() {
              this.$nextTick(() => {
                _this.refreshDynamicHeights();
              });
            },
          },
          computed: {
            imageMap() {
              return this.buildMapFromOptions((option) => option.data && option.data.product_image);
            },
            productTitleMap() {
              return this.buildMapFromOptions((option) => option.label);
            },
            variantsMap() {
              return this.buildMapFromOptions((option) => option.data && option.data.variants);
            },
            variantPositionMap() {
              return this.buildMapFromOptions((option) => option.data && option.data.variant_position);
            },
            colorSwatchMap() {
              return this.buildMapFromOptions((option) => {
                const rows =
                  option && option.data && Array.isArray(option.data.color_swatch_config)
                    ? option.data.color_swatch_config
                    : [];
                const map = {};
                rows.forEach((row) => {
                  if (!row || row.label == null) return;
                  const key = String(row.label).toLowerCase().trim();
                  const value = row.value;
                  if (key && value) map[key] = value;
                });
                return map;
              });
            },
            specificationImageMap() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_image);
            },
            specificationListMap() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_list);
            },
            minPriceMap() {
              return this.buildMapFromOptions((option) => option.min_price);
            },
            productUrlMap() {
              return this.buildMapFromOptions((option) => option.product_url);
            },
            specificationListGroup1Map() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_list_group_1);
            },
            specificationListGroup2Map() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_list_group_2);
            },
            specificationListGroup3Map() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_list_group_3);
            },
            specificationListGroup4Map() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_list_group_4);
            },
            specificationListGroup5Map() {
              return this.buildMapFromOptions((option) => option.data && option.data.specification_list_group_5);
            },
            hasVisibleComparisonData() {
              return this.hasVisiblePrimaryRows() || this.hasVisibleGroupedRows();
            },
          },
        });
      }
      handleClick(event) {
        const addButton = event.target && event.target.closest ? event.target.closest('.yg-product-button-add-to-cart') : null;
        if (!addButton || !this.contains(addButton)) return;

        event.preventDefault?.();
        this.handleAddToCart(addButton);
      }
      handleResize() {
        this.syncResponsiveState();
        this.refreshDynamicHeights();
        if (this.isFloatingTopBarEnabled) {
          this.requestFloatingNavStateUpdate();
        }
      }
      handleWindowScroll() {
        if (!this.isFloatingTopBarEnabled) return;
        this.requestFloatingNavStateUpdate();
      }
      handleTopBarScroll() {
        const targetKeys = this.isFloatingTopBarEnabled
          ? ['floating-top-bar-scroll', 'product-top-scroll', 'product-data-scroll']
          : ['product-top-scroll', 'product-data-scroll'];
        this.syncScroll('product-top-bar-scroll', targetKeys);
      }
      handleFloatingTopBarScroll() {
        if (!this.isFloatingTopBarEnabled) return;
        this.syncScroll('floating-top-bar-scroll', ['product-top-bar-scroll', 'product-top-scroll', 'product-data-scroll']);
      }
      handleTopScroll() {
        const targetKeys = this.isFloatingTopBarEnabled
          ? ['product-top-bar-scroll', 'floating-top-bar-scroll', 'product-data-scroll']
          : ['product-top-bar-scroll', 'product-data-scroll'];
        this.syncScroll('product-top-scroll', targetKeys);
      }
      handleDataScroll() {
        const targetKeys = this.isFloatingTopBarEnabled
          ? ['product-top-bar-scroll', 'floating-top-bar-scroll', 'product-top-scroll']
          : ['product-top-bar-scroll', 'product-top-scroll'];
        this.syncScroll('product-data-scroll', targetKeys);
      }
      syncScroll(sourceKey, targetKeys) {
        const source = this.sectionsEl[sourceKey];
        const nextTargetKeys = Array.isArray(targetKeys) ? targetKeys : [targetKeys];

        if (!source || this._syncingScroll) return;

        this._syncingScroll = true;
        nextTargetKeys.forEach((targetKey) => {
          const target = this.sectionsEl[targetKey];
          if (!target || target === source) return;
          if (target.scrollLeft === source.scrollLeft) return;
          target.scrollLeft = source.scrollLeft;
        });
        requestAnimationFrame(() => {
          this._syncingScroll = false;
        });
      }
      syncResponsiveState() {
        if (!this._vue) return;

        const isCondensedLayout =
          this.classList.contains('show-product-select') && window.matchMedia('(max-width: 1150px)').matches;
        this._vue.isCondensedLayout = isCondensedLayout;
      }
      closeTopBarDropdowns() {
        this.querySelectorAll('.yg-product-select').forEach((selectEl) => {
          const instance = selectEl.__vue__;
          if (!instance) return;

          if (typeof instance.blur === 'function') {
            instance.blur();
          }

          if ('visible' in instance) {
            instance.visible = false;
          }
        });

        const sectionId = this.dataset.sectionId;
        if (!sectionId) return;

        document.querySelectorAll(`.yg-product-compare-top-popper-${sectionId}`).forEach((popper) => {
          popper.style.display = 'none';
          popper.setAttribute('aria-hidden', 'true');
        });
      }
      getFloatingNavTopOffset() {
        const styles = getComputedStyle(this);
        const headerHeightValue = parseFloat(styles.getPropertyValue('--header-height'));
        const headerVisibleValue = parseFloat(styles.getPropertyValue('--header-is-visible'));
        const headerHeight = Number.isFinite(headerHeightValue) ? headerHeightValue : 0;
        const headerVisible = Number.isFinite(headerVisibleValue) ? headerVisibleValue : 1;
        return Math.max(0, (headerHeight - 1.5) * headerVisible);
      }
      requestFloatingNavStateUpdate() {
        if (!this.isFloatingTopBarEnabled) return;
        if (this._floatingNavFrame) return;

        this._floatingNavFrame = requestAnimationFrame(() => {
          this._floatingNavFrame = null;
          this.updateFloatingNavState();
        });
      }
      updateFloatingNavState() {
        if (!this.isFloatingTopBarEnabled) return;
        const floatingShell = this.sectionsEl['floating-top-bar-shell'];
        const sourceShell = this.sectionsEl['product-top-bar-shell'];
        const sourceScroll = this.sectionsEl['product-top-bar-scroll'];
        if (!floatingShell || !sourceShell || !sourceScroll) return;

        const stickyTop = this.getFloatingNavTopOffset();
        const sectionRect = this.getBoundingClientRect();
        const sourceShellRect = sourceShell.getBoundingClientRect();
        const sourceScrollRect = sourceScroll.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

        const isSectionVisible = sectionRect.top < viewportHeight && sectionRect.bottom > stickyTop;
        const hasSourceBarScrolledOut = sourceShellRect.bottom <= stickyTop;
        const shouldShowFloating = isSectionVisible && hasSourceBarScrolledOut;
        const wasFloatingActive = floatingShell.classList.contains('is-active');

        this.style.setProperty('--floating-nav-top', `${stickyTop}px`);
        this.style.setProperty('--floating-nav-left', `${sourceScrollRect.left}px`);
        this.style.setProperty('--floating-nav-width', `${sourceScrollRect.width}px`);

        if (wasFloatingActive !== shouldShowFloating) {
          this.closeTopBarDropdowns();
        }

        floatingShell.classList.toggle('is-active', shouldShowFloating);
        floatingShell.setAttribute('aria-hidden', shouldShowFloating ? 'false' : 'true');
      }
      refreshDynamicHeights() {
        requestAnimationFrame(() => {
          this.syncDropdownHeights();
          this.refreshCollapseButtons();
          const productData = this.sectionsEl['product-data'];
          if (productData && productData.hasAttribute('open')) {
            productData.style.height = 'auto';
          }
          if (this.isFloatingTopBarEnabled) {
            this.requestFloatingNavStateUpdate();
          }
        });
      }
      syncDropdownHeights() {
        this.querySelectorAll('yg-dropdown').forEach((dropdown) => {
          dropdown.setContentContainerHeight?.();
        });
      }
      refreshCollapseButtons() {
        this.querySelectorAll('yg-collapse-button').forEach((button) => {
          button.refresh?.();
        });
      }
      handleAddToCart(item) {
        const variantId = item?.dataset?.variantId || item?.getAttribute?.('data-variant-id');

        if (!variantId && !item.classList.contains('disabled')) return;

        const form = this.sectionsEl['product-form'];
        const idInput = this.sectionsEl['product-form-id'];
        if (!form || !idInput) return;

        idInput.value = String(variantId);
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        idInput.dispatchEvent(new Event('input', { bubbles: true }));

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
          return;
        }

        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn && typeof submitBtn.click === 'function') {
          submitBtn.click();
          return;
        }

        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    }
    if (!window.customElements.get('yg-product-compare-v3')) {
      window.customElements.define('yg-product-compare-v3', YGProductCompareV3);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-real-stories"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('yg-real-stories')) {
    class YGRealStories extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.handleClick);
        this.watchPreviewMediaQuery = window.matchMedia('(max-width: 699px)');
        this.watchPreviewMediaQuery.addEventListener?.('change', this.syncWatchPreviewPlayback);
        window.requestAnimationFrame(this.syncWatchPreviewPlayback);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.watchPreviewMediaQuery?.removeEventListener?.('change', this.syncWatchPreviewPlayback);
        this.unbindFallbackPopup();
      }

      syncWatchPreviewPlayback = () => {
        const $previewVideo = this.querySelector('.yg-real-stories__watch-preview');

        if (!$previewVideo) {
          return;
        }

        if (!this.watchPreviewMediaQuery?.matches) {
          $previewVideo.pause();
          return;
        }

        $previewVideo.muted = true;
        $previewVideo.loop = true;
        $previewVideo.playsInline = true;
        $previewVideo.preload = 'auto';

        if (!$previewVideo.currentSrc) {
          $previewVideo.load();
        }

        $previewVideo.play().catch(() => {});
      };

      handleFallbackPopupClick = (event) => {
        const $popup = this.$fallbackPopup;

        if (!$popup || (!event.target.closest('.yg-popup-box-close') && event.target !== $popup)) {
          return;
        }

        $popup.style.display = 'none';
        const $content = $popup.querySelector('.yg-popup-box-content-inner');

        if ($content) {
          $content.innerHTML = '';
        }

        document.body.style.overflow = this.previousBodyOverflow || '';
      };

      bindFallbackPopup($popup) {
        if (this.$fallbackPopup === $popup) {
          return;
        }

        this.unbindFallbackPopup();
        this.$fallbackPopup = $popup;
        this.$fallbackPopup.addEventListener('click', this.handleFallbackPopupClick);
      }

      unbindFallbackPopup() {
        this.$fallbackPopup?.removeEventListener('click', this.handleFallbackPopupClick);
        this.$fallbackPopup = null;
      }

      openMobileVideo($template) {
        const $popupTemplate = document.createElement('template');
        $popupTemplate.innerHTML = $template.innerHTML;

        this.dispatchEvent(
          new CustomEvent('YG:openPopup', {
            bubbles: true,
            detail: { popupTemplate: $popupTemplate },
          })
        );

        const $popup = document.querySelector('yg-popup-box');

        if (!$popup) {
          return;
        }

        if (!window.customElements.get('yg-popup-box')) {
          const $content = $popup.querySelector('.yg-popup-box-content-inner');

          if (!$content) {
            return;
          }

          $content.innerHTML = $popupTemplate.innerHTML;
          this.previousBodyOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          $popup.style.display = 'flex';
          this.bindFallbackPopup($popup);
        }

        const $popupVideo = $popup.querySelector('.yg-real-stories__video-player video');
        $popupVideo?.play().catch(() => {});
      }

      handleClick = (event) => {
        const $trigger = event.target.closest('[data-yg-real-stories-play]');

        if (!$trigger) {
          return;
        }

        const $video = $trigger.closest('.yg-real-stories__video');
        const $template = $video?.querySelector('[data-yg-real-stories-video-template]');

        if (!$video || !$template) {
          return;
        }

        if (window.matchMedia('(max-width: 699px)').matches) {
          this.openMobileVideo($template);
          return;
        }

        if ($video.classList.contains('is-playing')) {
          return;
        }

        const $player = $template.content.cloneNode(true);
        $video.appendChild($player);
        $video.classList.add('is-playing');

        $video
          .querySelector('video')
          ?.play()
          .catch(() => {});
      };
    }

    window.customElements.define('yg-real-stories', YGRealStories);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-slideshow"] && !Shopify.designMode) return;
  try {
    
  class YGSlideshowProgressDots extends HTMLElement {
    connectedCallback() {
      this.$pageDots = this.querySelector('page-dots');
      this.$buttons = Array.from(this.querySelectorAll('page-dots > button'));
      this.duration = Number(this.getAttribute('duration')) * 1000;
      this.animationFrame = null;
      this.observer = new MutationObserver(this.handleSelectionChange);

      this.observer.observe(this.$pageDots, {
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-current']
      });

      this.startProgress();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      window.cancelAnimationFrame(this.animationFrame);
    }

    handleSelectionChange = () => {
      this.startProgress();
    };

    startProgress() {
      window.cancelAnimationFrame(this.animationFrame);

      const $activeButton = this.$buttons.find(($button) => $button.getAttribute('aria-current') === 'true');

      this.$buttons.forEach(($button) => {
        $button.style.setProperty('--yg-slideshow-progress', $button === $activeButton && !this.hasAttribute('autoplay') ? '1' : '0');
      });

      if (!$activeButton || !this.hasAttribute('autoplay') || !this.duration) {
        return;
      }

      const startTime = window.performance.now();
      const updateProgress = (currentTime) => {
        const progress = Math.min((currentTime - startTime) / this.duration, 1);
        $activeButton.style.setProperty('--yg-slideshow-progress', progress.toString());

        if (progress < 1) {
          this.animationFrame = window.requestAnimationFrame(updateProgress);
        }
      };

      this.animationFrame = window.requestAnimationFrame(updateProgress);
    }
  }

  if (!window.customElements.get('yg-slideshow-progress-dots')) {
    window.customElements.define('yg-slideshow-progress-dots', YGSlideshowProgressDots);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-tabs-03-product"] && !Shopify.designMode) return;
  try {
    
  class YGTabs03Product extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0;
      this.mediaSwiper = null;
      this.contentSwiper = null;
      this.resizeFrame = null;
      this.mountTimer = null;
      this.handleTabClick = this.handleTabClick.bind(this);
      this.handleTabKeydown = this.handleTabKeydown.bind(this);
      this.handleMediaSlideChange = this.handleMediaSlideChange.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    get sectionElements() {
      if (this._sectionElements) {
        return this._sectionElements;
      }

      this._sectionElements = {
        tabsTrack: this.querySelector('[data-tabs-track]'),
        tabsScrollContainer: this.querySelector('[data-tabs-scroll]'),
        tabs: Array.from(this.querySelectorAll('.yg-tabs-03__tab')),
        mediaSwiper: this.querySelector('[data-media-swiper]'),
        contentSwiper: this.querySelector('[data-content-swiper]'),
        contentSlides: Array.from(this.querySelectorAll('.yg-tabs-03__content-slide')),
      };

      return this._sectionElements;
    }

    connectedCallback() {
      if (this.initialized) {
        return;
      }

      this.initialized = true;

      this.sectionElements.tabs.forEach((tab) => {
        tab.addEventListener('click', this.handleTabClick);
      });

      this.sectionElements.tabsTrack?.addEventListener('keydown', this.handleTabKeydown);
      window.addEventListener('resize', this.handleResize);

      this.contentWidth = null;
      this.resizeObserver = new ResizeObserver((entries) => {
        const needsUpdate = entries.some((entry) => {
          if (entry.target !== this.sectionElements.contentSwiper) {
            return true;
          }

          const width = entry.contentRect.width;
          if (width === this.contentWidth) {
            return false;
          }

          this.contentWidth = width;
          return true;
        });

        if (needsUpdate) {
          this.handleResize();
        }
      });

      if (this.sectionElements.contentSwiper) {
        this.resizeObserver.observe(this.sectionElements.contentSwiper);
      }
      this.querySelectorAll('.yg-tabs-03__content-inner').forEach((content) => {
        this.resizeObserver.observe(content);
      });
      if (this.sectionElements.tabsTrack) {
        this.resizeObserver.observe(this.sectionElements.tabsTrack);
      }

      this.mountSwipers();
    }

    disconnectedCallback() {
      this.sectionElements.tabs.forEach((tab) => {
        tab.removeEventListener('click', this.handleTabClick);
      });

      this.sectionElements.tabsTrack?.removeEventListener('keydown', this.handleTabKeydown);
      window.removeEventListener('resize', this.handleResize);
      this.resizeObserver?.disconnect();
      window.cancelAnimationFrame(this.resizeFrame);
      window.clearTimeout(this.mountTimer);
      this.resizeFrame = null;
      this.mountTimer = null;

      if (this.mediaSwiper) {
        this.mediaSwiper.off('slideChange', this.handleMediaSlideChange);
        this.mediaSwiper = null;
      }

      if (this.contentSwiper) {
        this.contentSwiper.off('resize', this.handleResize);
        this.contentSwiper = null;
      }

      this.initialized = false;
    }

    mountSwipers(attempt = 0) {
      if (!this.isConnected) {
        return;
      }

      const mediaSwiperElement = this.sectionElements.mediaSwiper;
      const contentSwiperElement = this.sectionElements.contentSwiper;

      if (!mediaSwiperElement || !contentSwiperElement) {
        return;
      }

      if (!mediaSwiperElement.swiper || !contentSwiperElement.swiper) {
        if (attempt < 10) {
          this.mountTimer = window.setTimeout(() => this.mountSwipers(attempt + 1), 150);
        }
        return;
      }

      if (!this.mediaSwiper) {
        this.mediaSwiper = mediaSwiperElement.swiper;
        this.mediaSwiper.on('slideChange', this.handleMediaSlideChange);
      }

      if (!this.contentSwiper) {
        this.contentSwiper = contentSwiperElement.swiper;
        this.contentSwiper.on('resize', this.handleResize);
      }

      this.mediaSwiper.allowTouchMove = this.sectionElements.tabs.length > 1;
      this.mediaSwiper.params.allowTouchMove = this.sectionElements.tabs.length > 1;
      this.contentSwiper.allowTouchMove = false;
      this.contentSwiper.params.allowTouchMove = false;
      this.contentSwiper.params.autoHeight = true;

      this.setActiveState(this.activeIndex, {
        syncSwiper: false,
        scrollBehavior: 'auto',
      });
    }

    handleTabClick(event) {
      const tab = event.currentTarget;
      const index = Number(tab.dataset.tabIndex);

      this.setActiveState(index);
    }

    handleTabKeydown(event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        return;
      }

      const currentIndex = this.activeIndex;
      const lastIndex = this.sectionElements.tabs.length - 1;
      let nextIndex = currentIndex;

      if (event.key == 'ArrowLeft') {
        nextIndex = currentIndex > 0 ? currentIndex - 1 : lastIndex;
      } else if (event.key == 'ArrowRight') {
        nextIndex = currentIndex < lastIndex ? currentIndex + 1 : 0;
      } else if (event.key == 'Home') {
        nextIndex = 0;
      } else if (event.key == 'End') {
        nextIndex = lastIndex;
      }

      event.preventDefault();

      const nextTab = this.sectionElements.tabs[nextIndex];
      if (nextTab) {
        nextTab.focus();
      }

      this.setActiveState(nextIndex);
    }

    handleMediaSlideChange() {
      const nextIndex =
        typeof this.mediaSwiper.realIndex === 'number' ? this.mediaSwiper.realIndex : this.mediaSwiper.activeIndex;

      if (this.contentSwiper && this.contentSwiper.activeIndex !== nextIndex) {
        this.contentSwiper.slideTo(nextIndex);
      }

      this.setActiveState(nextIndex, {
        syncSwiper: false,
      });
    }

    handleResize() {
      if (!this.isConnected || this.resizeFrame !== null) {
        return;
      }

      this.resizeFrame = window.requestAnimationFrame(() => {
        this.resizeFrame = null;
        this.updateLayout();
      });
    }

    updateLayout() {
      this.updateOverflowState();
      this.updateIndicator();

      if (this.isTabsOverflowing()) {
        this.scrollActiveTabIntoView('auto');
      } else if (this.sectionElements.tabsScrollContainer) {
        this.sectionElements.tabsScrollContainer.scrollLeft = 0;
      }

      if (this.contentSwiper && !this.contentSwiper.destroyed && this.sectionElements.contentSwiper.clientWidth > 0) {
        this.contentSwiper.update();
        this.contentSwiper.updateAutoHeight(0);
      }
    }

    isTabsOverflowing() {
      const scrollContainer = this.sectionElements.tabsScrollContainer;

      if (!scrollContainer) {
        return false;
      }

      return scrollContainer.scrollWidth > scrollContainer.clientWidth + 1;
    }

    scrollActiveTabIntoView(behavior = 'smooth') {
      const scrollContainer = this.sectionElements.tabsScrollContainer;
      const activeTab = this.sectionElements.tabs[this.activeIndex];

      if (!activeTab || !scrollContainer) {
        return;
      }

      if (this.isTabsOverflowing()) {
        const containerRect = scrollContainer.getBoundingClientRect();
        const itemRect = activeTab.getBoundingClientRect();
        const currentScrollLeft = scrollContainer.scrollLeft;
        const rawScrollLeft =
          currentScrollLeft + (itemRect.left - containerRect.left) - (scrollContainer.clientWidth - itemRect.width) / 2;
        const maxScrollLeft = Math.max(scrollContainer.scrollWidth - scrollContainer.clientWidth, 0);
        const nextScrollLeft = Math.min(Math.max(rawScrollLeft, 0), maxScrollLeft);

        if (typeof scrollContainer.scrollTo === 'function') {
          scrollContainer.scrollTo({
            left: nextScrollLeft,
            behavior: behavior,
          });
        } else {
          scrollContainer.scrollLeft = nextScrollLeft;
        }
      }
    }

    updateOverflowState() {
      const scrollContainer = this.sectionElements.tabsScrollContainer;

      if (!scrollContainer) {
        return;
      }

      scrollContainer.classList.toggle('is-overflowing', this.isTabsOverflowing());
    }

    updateIndicator() {
      const tabsTrack = this.sectionElements.tabsTrack;
      const activeTab = this.sectionElements.tabs[this.activeIndex];

      if (!tabsTrack || !activeTab) {
        return;
      }

      tabsTrack.style.setProperty('--tabs-03-indicator-left', `${activeTab.offsetLeft}px`);
      tabsTrack.style.setProperty('--tabs-03-indicator-width', `${activeTab.offsetWidth}px`);
    }

    pauseAllVideos() {
      this.querySelectorAll('.yg-tabs-03__media-slide yg-video').forEach((videoElement) => {
        if (typeof videoElement.pauseVideo === 'function') {
          videoElement.pauseVideo();
        }
      });
    }

    playActiveVideo() {
      this.pauseAllVideos();

      const activeSlide = this.querySelector(`.yg-tabs-03__media-slide[data-slide-index="${this.activeIndex}"]`);
      const activeVideo = activeSlide?.querySelector('yg-video');

      if (activeVideo && typeof activeVideo.playVideo === 'function') {
        activeVideo.playVideo();
      }
    }

    setActiveState(index, options = {}) {
      const safeIndex = Math.max(0, Math.min(index, this.sectionElements.tabs.length - 1));
      const syncSwiper = options.syncSwiper !== false;
      const scrollBehavior = options.scrollBehavior || 'smooth';

      this.activeIndex = safeIndex;

      if (syncSwiper) {
        if (this.mediaSwiper && this.mediaSwiper.activeIndex !== safeIndex) {
          this.mediaSwiper.slideTo(safeIndex);
        }

        if (this.contentSwiper && this.contentSwiper.activeIndex !== safeIndex) {
          this.contentSwiper.slideTo(safeIndex);
        }
      }

      this.sectionElements.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === safeIndex;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.sectionElements.contentSlides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', slideIndex === safeIndex ? 'false' : 'true');
      });

      this.updateOverflowState();
      this.updateIndicator();

      if (this.isTabsOverflowing()) {
        this.scrollActiveTabIntoView(scrollBehavior);
      } else if (this.sectionElements.tabsScrollContainer) {
        this.sectionElements.tabsScrollContainer.scrollLeft = 0;
      }

      this.playActiveVideo();

      this.handleResize();
    }
  }

  if (!window.customElements.get('yg-tabs-03-product')) {
    window.customElements.define('yg-tabs-03-product', YGTabs03Product);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-tabs-03"] && !Shopify.designMode) return;
  try {
    
    class YGTabs03 extends HTMLElement {
      constructor() {
        super();
        this.activeIndex = 0;
        this.mediaSwiper = null;
        this.contentSwiper = null;
        this.handleTabClick = this.handleTabClick.bind(this);
        this.handleTabKeydown = this.handleTabKeydown.bind(this);
        this.handleMediaSlideChange = this.handleMediaSlideChange.bind(this);
        this.handleResize = this.handleResize.bind(this);
      }

      get sectionElements() {
        if (this._sectionElements) {
          return this._sectionElements;
        }

        this._sectionElements = {
          tabsTrack: this.querySelector('[data-tabs-track]'),
          tabsScrollContainer: this.querySelector('[data-tabs-scroll]'),
          tabs: Array.from(this.querySelectorAll('.yg-tabs-03__tab')),
          mediaSwiper: this.querySelector('[data-media-swiper]'),
          contentSwiper: this.querySelector('[data-content-swiper]'),
          contentSlides: Array.from(this.querySelectorAll('.yg-tabs-03__content-slide')),
        };

        return this._sectionElements;
      }

      connectedCallback() {
        if (this.initialized) {
          return;
        }

        this.initialized = true;

        this.sectionElements.tabs.forEach((tab) => {
          tab.addEventListener('click', this.handleTabClick);
        });

        this.sectionElements.tabsTrack?.addEventListener('keydown', this.handleTabKeydown);
        window.addEventListener('resize', this.handleResize);

        this.mountSwipers();
      }

      disconnectedCallback() {
        this.sectionElements.tabs.forEach((tab) => {
          tab.removeEventListener('click', this.handleTabClick);
        });

        this.sectionElements.tabsTrack?.removeEventListener('keydown', this.handleTabKeydown);
        window.removeEventListener('resize', this.handleResize);

        if (this.mediaSwiper) {
          this.mediaSwiper.off('slideChange', this.handleMediaSlideChange);
          this.mediaSwiper = null;
        }

        if (this.contentSwiper) {
          this.contentSwiper = null;
        }

        this.initialized = false;
      }

      mountSwipers(attempt = 0) {
        const mediaSwiperElement = this.sectionElements.mediaSwiper;
        const contentSwiperElement = this.sectionElements.contentSwiper;

        if (!mediaSwiperElement || !contentSwiperElement) {
          return;
        }

        if (!mediaSwiperElement.swiper || !contentSwiperElement.swiper) {
          if (attempt < 10) {
            window.setTimeout(() => this.mountSwipers(attempt + 1), 150);
          }
          return;
        }

        if (!this.mediaSwiper) {
          this.mediaSwiper = mediaSwiperElement.swiper;
          this.mediaSwiper.on('slideChange', this.handleMediaSlideChange);
        }

        if (!this.contentSwiper) {
          this.contentSwiper = contentSwiperElement.swiper;
        }

        this.mediaSwiper.allowTouchMove = this.sectionElements.tabs.length > 1;
        this.mediaSwiper.params.allowTouchMove = this.sectionElements.tabs.length > 1;
        this.contentSwiper.allowTouchMove = false;
        this.contentSwiper.params.allowTouchMove = false;
        this.contentSwiper.params.autoHeight = true;

        this.setActiveState(0, {
          syncSwiper: false,
          scrollBehavior: 'auto',
        });
      }

      handleTabClick(event) {
        const tab = event.currentTarget;
        const index = Number(tab.dataset.tabIndex);

        this.setActiveState(index);
      }

      handleTabKeydown(event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
          return;
        }

        const currentIndex = this.activeIndex;
        const lastIndex = this.sectionElements.tabs.length - 1;
        let nextIndex = currentIndex;

        if (event.key == 'ArrowLeft') {
          nextIndex = currentIndex > 0 ? currentIndex - 1 : lastIndex;
        } else if (event.key == 'ArrowRight') {
          nextIndex = currentIndex < lastIndex ? currentIndex + 1 : 0;
        } else if (event.key == 'Home') {
          nextIndex = 0;
        } else if (event.key == 'End') {
          nextIndex = lastIndex;
        }

        event.preventDefault();

        const nextTab = this.sectionElements.tabs[nextIndex];
        if (nextTab) {
          nextTab.focus();
        }

        this.setActiveState(nextIndex);
      }

      handleMediaSlideChange() {
        const nextIndex = typeof this.mediaSwiper.realIndex === 'number'
          ? this.mediaSwiper.realIndex
          : this.mediaSwiper.activeIndex;

        if (this.contentSwiper && this.contentSwiper.activeIndex !== nextIndex) {
          this.contentSwiper.slideTo(nextIndex);
        }

        this.setActiveState(nextIndex, {
          syncSwiper: false,
        });
      }

      handleResize() {
        this.updateOverflowState();
        this.updateIndicator();

        if (this.isTabsOverflowing()) {
          this.scrollActiveTabIntoView('auto');
        } else if (this.sectionElements.tabsScrollContainer) {
          this.sectionElements.tabsScrollContainer.scrollLeft = 0;
        }

        if (this.contentSwiper) {
          this.contentSwiper.updateAutoHeight(0);
        }
      }

      isTabsOverflowing() {
        const scrollContainer = this.sectionElements.tabsScrollContainer;

        if (!scrollContainer) {
          return false;
        }

        return scrollContainer.scrollWidth > scrollContainer.clientWidth + 1;
      }

      scrollActiveTabIntoView(behavior = 'smooth') {
        const scrollContainer = this.sectionElements.tabsScrollContainer;
        const activeTab = this.sectionElements.tabs[this.activeIndex];

        if (!activeTab || !scrollContainer) {
          return;
        }

        if (this.isTabsOverflowing()) {
          const containerRect = scrollContainer.getBoundingClientRect();
          const itemRect = activeTab.getBoundingClientRect();
          const currentScrollLeft = scrollContainer.scrollLeft;
          const rawScrollLeft = currentScrollLeft + (itemRect.left - containerRect.left) - ((scrollContainer.clientWidth - itemRect.width) / 2);
          const maxScrollLeft = Math.max(scrollContainer.scrollWidth - scrollContainer.clientWidth, 0);
          const nextScrollLeft = Math.min(Math.max(rawScrollLeft, 0), maxScrollLeft);

          if (typeof scrollContainer.scrollTo === 'function') {
            scrollContainer.scrollTo({
              left: nextScrollLeft,
              behavior: behavior,
            });
          } else {
            scrollContainer.scrollLeft = nextScrollLeft;
          }
        }
      }

      updateOverflowState() {
        const scrollContainer = this.sectionElements.tabsScrollContainer;

        if (!scrollContainer) {
          return;
        }

        scrollContainer.classList.toggle('is-overflowing', this.isTabsOverflowing());
      }

      updateIndicator() {
        const tabsTrack = this.sectionElements.tabsTrack;
        const activeTab = this.sectionElements.tabs[this.activeIndex];

        if (!tabsTrack || !activeTab) {
          return;
        }

        tabsTrack.style.setProperty('--tabs-03-indicator-left', `${activeTab.offsetLeft}px`);
        tabsTrack.style.setProperty('--tabs-03-indicator-width', `${activeTab.offsetWidth}px`);
      }

      pauseAllVideos() {
        this.querySelectorAll('.yg-tabs-03__media-slide yg-video').forEach((videoElement) => {
          if (typeof videoElement.pauseVideo === 'function') {
            videoElement.pauseVideo();
          }
        });
      }

      playActiveVideo() {
        this.pauseAllVideos();

        const activeSlide = this.querySelector(`.yg-tabs-03__media-slide[data-slide-index="${this.activeIndex}"]`);
        const activeVideo = activeSlide?.querySelector('yg-video');

        if (activeVideo && typeof activeVideo.playVideo === 'function') {
          activeVideo.playVideo();
        }
      }

      setActiveState(index, options = {}) {
        const safeIndex = Math.max(0, Math.min(index, this.sectionElements.tabs.length - 1));
        const syncSwiper = options.syncSwiper !== false;
        const scrollBehavior = options.scrollBehavior || 'smooth';

        this.activeIndex = safeIndex;

        if (syncSwiper) {
          if (this.mediaSwiper && this.mediaSwiper.activeIndex !== safeIndex) {
            this.mediaSwiper.slideTo(safeIndex);
          }

          if (this.contentSwiper && this.contentSwiper.activeIndex !== safeIndex) {
            this.contentSwiper.slideTo(safeIndex);
          }
        }

        this.sectionElements.tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === safeIndex;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        this.sectionElements.contentSlides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', slideIndex === safeIndex ? 'false' : 'true');
        });

        this.updateOverflowState();
        this.updateIndicator();

        if (this.isTabsOverflowing()) {
          this.scrollActiveTabIntoView(scrollBehavior);
        } else if (this.sectionElements.tabsScrollContainer) {
          this.sectionElements.tabsScrollContainer.scrollLeft = 0;
        }

        this.playActiveVideo();

        if (this.contentSwiper) {
          this.contentSwiper.updateAutoHeight(0);
        }
      }
    }

    if (!window.customElements.get('yg-tabs-03')) {
      window.customElements.define('yg-tabs-03', YGTabs03);
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-tabs-image"] && !Shopify.designMode) return;
  try {
    
  class YGTabs03 extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0;
      this.mediaSwiper = null;
      this.contentSwiper = null;
      this.handleTabClick = this.handleTabClick.bind(this);
      this.handleTabKeydown = this.handleTabKeydown.bind(this);
      this.handleMediaSlideChange = this.handleMediaSlideChange.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    get sectionElements() {
      if (this._sectionElements) {
        return this._sectionElements;
      }

      this._sectionElements = {
        tabsTrack: this.querySelector('[data-tabs-track]'),
        tabsScrollContainer: this.querySelector('[data-tabs-scroll]'),
        tabs: Array.from(this.querySelectorAll('.yg-tabs-03__tab')),
        mediaSwiper: this.querySelector('[data-media-swiper]'),
        contentSwiper: this.querySelector('[data-content-swiper]'),
        contentSlides: Array.from(this.querySelectorAll('.yg-tabs-03__content-slide')),
      };

      return this._sectionElements;
    }

    connectedCallback() {
      if (this.initialized) {
        return;
      }

      this.initialized = true;

      this.sectionElements.tabs.forEach((tab) => {
        tab.addEventListener('click', this.handleTabClick);
      });

      this.sectionElements.tabsTrack?.addEventListener('keydown', this.handleTabKeydown);
      window.addEventListener('resize', this.handleResize);

      this.mountSwipers();
    }

    disconnectedCallback() {
      this.sectionElements.tabs.forEach((tab) => {
        tab.removeEventListener('click', this.handleTabClick);
      });

      this.sectionElements.tabsTrack?.removeEventListener('keydown', this.handleTabKeydown);
      window.removeEventListener('resize', this.handleResize);

      if (this.mediaSwiper) {
        this.mediaSwiper.off('slideChange', this.handleMediaSlideChange);
        this.mediaSwiper = null;
      }

      if (this.contentSwiper) {
        this.contentSwiper = null;
      }

      this.initialized = false;
    }

    mountSwipers(attempt = 0) {
      const mediaSwiperElement = this.sectionElements.mediaSwiper;
      const contentSwiperElement = this.sectionElements.contentSwiper;

      if (!mediaSwiperElement || !contentSwiperElement) {
        return;
      }

      if (!mediaSwiperElement.swiper || !contentSwiperElement.swiper) {
        if (attempt < 10) {
          window.setTimeout(() => this.mountSwipers(attempt + 1), 150);
        }
        return;
      }

      if (!this.mediaSwiper) {
        this.mediaSwiper = mediaSwiperElement.swiper;
        this.mediaSwiper.on('slideChange', this.handleMediaSlideChange);
      }

      if (!this.contentSwiper) {
        this.contentSwiper = contentSwiperElement.swiper;
      }

      this.mediaSwiper.allowTouchMove = this.sectionElements.tabs.length > 1;
      this.mediaSwiper.params.allowTouchMove = this.sectionElements.tabs.length > 1;
      this.contentSwiper.allowTouchMove = false;
      this.contentSwiper.params.allowTouchMove = false;
      this.contentSwiper.params.autoHeight = true;

      this.setActiveState(0, {
        syncSwiper: false,
        scrollBehavior: 'auto',
      });
    }

    handleTabClick(event) {
      const tab = event.currentTarget;
      const index = Number(tab.dataset.tabIndex);

      this.setActiveState(index);
    }

    handleTabKeydown(event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        return;
      }

      const currentIndex = this.activeIndex;
      const lastIndex = this.sectionElements.tabs.length - 1;
      let nextIndex = currentIndex;

      if (event.key == 'ArrowLeft') {
        nextIndex = currentIndex > 0 ? currentIndex - 1 : lastIndex;
      } else if (event.key == 'ArrowRight') {
        nextIndex = currentIndex < lastIndex ? currentIndex + 1 : 0;
      } else if (event.key == 'Home') {
        nextIndex = 0;
      } else if (event.key == 'End') {
        nextIndex = lastIndex;
      }

      event.preventDefault();

      const nextTab = this.sectionElements.tabs[nextIndex];
      if (nextTab) {
        nextTab.focus();
      }

      this.setActiveState(nextIndex);
    }

    handleMediaSlideChange() {
      const nextIndex =
        typeof this.mediaSwiper.realIndex === 'number' ? this.mediaSwiper.realIndex : this.mediaSwiper.activeIndex;

      if (this.contentSwiper && this.contentSwiper.activeIndex !== nextIndex) {
        this.contentSwiper.slideTo(nextIndex);
      }

      this.setActiveState(nextIndex, {
        syncSwiper: false,
      });
    }

    handleResize() {
      this.updateOverflowState();
      this.updateIndicator();

      if (this.isTabsOverflowing()) {
        this.scrollActiveTabIntoView('auto');
      } else if (this.sectionElements.tabsScrollContainer) {
        this.sectionElements.tabsScrollContainer.scrollLeft = 0;
      }

      if (this.contentSwiper) {
        this.contentSwiper.updateAutoHeight(0);
      }
    }

    isTabsOverflowing() {
      const scrollContainer = this.sectionElements.tabsScrollContainer;

      if (!scrollContainer) {
        return false;
      }

      return scrollContainer.scrollWidth > scrollContainer.clientWidth + 1;
    }

    scrollActiveTabIntoView(behavior = 'smooth') {
      const scrollContainer = this.sectionElements.tabsScrollContainer;
      const activeTab = this.sectionElements.tabs[this.activeIndex];

      if (!activeTab || !scrollContainer) {
        return;
      }

      if (this.isTabsOverflowing()) {
        const containerRect = scrollContainer.getBoundingClientRect();
        const itemRect = activeTab.getBoundingClientRect();
        const currentScrollLeft = scrollContainer.scrollLeft;
        const rawScrollLeft =
          currentScrollLeft + (itemRect.left - containerRect.left) - (scrollContainer.clientWidth - itemRect.width) / 2;
        const maxScrollLeft = Math.max(scrollContainer.scrollWidth - scrollContainer.clientWidth, 0);
        const nextScrollLeft = Math.min(Math.max(rawScrollLeft, 0), maxScrollLeft);

        if (typeof scrollContainer.scrollTo === 'function') {
          scrollContainer.scrollTo({
            left: nextScrollLeft,
            behavior: behavior,
          });
        } else {
          scrollContainer.scrollLeft = nextScrollLeft;
        }
      }
    }

    updateOverflowState() {
      const scrollContainer = this.sectionElements.tabsScrollContainer;

      if (!scrollContainer) {
        return;
      }

      scrollContainer.classList.toggle('is-overflowing', this.isTabsOverflowing());
    }

    updateIndicator() {
      const tabsTrack = this.sectionElements.tabsTrack;
      const activeTab = this.sectionElements.tabs[this.activeIndex];

      if (!tabsTrack || !activeTab) {
        return;
      }

      tabsTrack.style.setProperty('--tabs-03-indicator-left', `${activeTab.offsetLeft}px`);
      tabsTrack.style.setProperty('--tabs-03-indicator-width', `${activeTab.offsetWidth}px`);
    }

    pauseAllVideos() {
      this.querySelectorAll('.yg-tabs-03__media-slide yg-video').forEach((videoElement) => {
        if (typeof videoElement.pauseVideo === 'function') {
          videoElement.pauseVideo();
        }
      });
    }

    playActiveVideo() {
      this.pauseAllVideos();

      const activeSlide = this.querySelector(`.yg-tabs-03__media-slide[data-slide-index="${this.activeIndex}"]`);
      const activeVideo = activeSlide?.querySelector('yg-video');

      if (activeVideo && typeof activeVideo.playVideo === 'function') {
        activeVideo.playVideo();
      }
    }

    setActiveState(index, options = {}) {
      const safeIndex = Math.max(0, Math.min(index, this.sectionElements.tabs.length - 1));
      const syncSwiper = options.syncSwiper !== false;
      const scrollBehavior = options.scrollBehavior || 'smooth';

      this.activeIndex = safeIndex;

      if (syncSwiper) {
        if (this.mediaSwiper && this.mediaSwiper.activeIndex !== safeIndex) {
          this.mediaSwiper.slideTo(safeIndex);
        }

        if (this.contentSwiper && this.contentSwiper.activeIndex !== safeIndex) {
          this.contentSwiper.slideTo(safeIndex);
        }
      }

      this.sectionElements.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === safeIndex;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.sectionElements.contentSlides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', slideIndex === safeIndex ? 'false' : 'true');
      });

      this.updateOverflowState();
      this.updateIndicator();

      if (this.isTabsOverflowing()) {
        this.scrollActiveTabIntoView(scrollBehavior);
      } else if (this.sectionElements.tabsScrollContainer) {
        this.sectionElements.tabsScrollContainer.scrollLeft = 0;
      }

      this.playActiveVideo();

      if (this.contentSwiper) {
        this.contentSwiper.updateAutoHeight(0);
      }
    }
  }

  if (!window.customElements.get('yg-tabs-03')) {
    window.customElements.define('yg-tabs-03', YGTabs03);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-taiji-ring"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('yg-taiji-ring')) {
    class YGTaijiRing extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', this.handleVariantChange);

        if (this.observer) {
          return;
        }

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
          this.classList.add('is-revealed');
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) {
              return;
            }

            this.observer.disconnect();
            this.observer = null;
            this.classList.add('is-revealed');
          },
          { threshold: 0.5 }
        );

        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.handleVariantChange);
        this.observer?.disconnect();
        this.observer = null;
      }

      handleVariantChange = (event) => {
        const $input = event.target;

        if (!$input.matches('input[data-variant-id]')) {
          return;
        }

        const variantId = $input.dataset.variantId;
        const $variantInput = this.querySelector('input[name="id"]');

        if ($variantInput) {
          $variantInput.value = variantId;
        }

        this.querySelectorAll('[data-yg-taiji-product-link]').forEach(($link) => {
          const url = new URL($link.href, window.location.origin);
          url.searchParams.set('variant', variantId);
          $link.href = `${url.pathname}${url.search}${url.hash}`;
        });

        if (!$input.dataset.variantMedia) {
          return;
        }

        const media = JSON.parse($input.dataset.variantMedia);
        const imageSource = media.preview_image?.src || media.src;
        const $image = this.querySelector('[data-yg-taiji-ring-product-image]');

        if (!imageSource || !$image || $image.src === imageSource) {
          return;
        }

        $image.style.opacity = '0';
        $image.removeAttribute('srcset');
        $image.removeAttribute('sizes');
        $image.src = imageSource;
        $image.alt = media.alt || $image.alt;

        $image.addEventListener('load', () => {
          $image.style.opacity = '1';
        }, { once: true });
      };
    }

    window.customElements.define('yg-taiji-ring', YGTaijiRing);
  }

  } catch(e) { console.error(e); }
})();
})();
